import { IDENTITY_CLIENT_GROUP, IDENTITY_ADMIN_GROUP } from "../const/Group";

/**
 * Config Group
 */
export const GroupClient: string = IDENTITY_CLIENT_GROUP;
export const GroupAdmin: string = IDENTITY_ADMIN_GROUP;
export const GroupCreate: string | undefined = process.env.REACT_APP_CREATE_GROUP;
export const AdminCodeRole: string | undefined = process.env.REACT_APP_ADMIN_CODE_ROLE;